import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule, provideErrorTracking, cookielessBearerHostInterceptor } from '@galaxy/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ShoppableFeedComponent } from './feed/shoppable-feed.component';
import { GalaxyDefaultProviderOverrides } from '@vendasta/galaxy/provider-default-overrides';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AppComponent, ShoppableFeedComponent],
  bootstrap: [AppComponent],
  imports: [
    CoreModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatMenuModule,
  ],
  providers: [
    provideErrorTracking(),
    ...GalaxyDefaultProviderOverrides,
    // Cookieless last: earlier interceptors read withCredentials to decide whether to attach the bearer.
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([cookielessBearerHostInterceptor])),
  ],
})
export class AppModule {}
